import { get } from 'lodash'

export const getId = data => {
  if (get(data, 'activity')) {
    return get(data, 'activity.id')
  }

  if (get(data, 'activityCategory')) {
    return get(data, 'activityCategory.id')
  }

  if (get(data, 'ajEvent')) {
    return get(data, 'ajEvent.id')
  }

  if (get(data, 'residentialProject')) {
    return get(data, 'residentialProject.id')
  }
}
